import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryHolder } from 'src/app/holders/category-holder';
import { ItemDisplayData } from 'src/app/models/item-display-data';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { ItemMenuService } from 'src/app/services/item-menu.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-menu-itens',
  templateUrl: './menu-itens.component.html',
  styleUrls: ['./menu-itens.component.scss'],
})
export class MenuItensComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.orderitemcount > 0) $event.returnValue = true;
  }

  _categories: Array<CategoryHolder> = new Array<CategoryHolder>();
  canDeactivate: boolean = false;
  orderitemcount: number = 0;
  showOrderBar: boolean = false;
  isRedirect: boolean = false;

  constructor(
    private itemmenuservice: ItemMenuService,
    private initializationservice: InitializationService,
    private route: ActivatedRoute,
    private router: Router,
    private currentorderservice: CurrentOrderService,
    private navigationservice: NavigationService,
    public alertDialog: MatDialog,
    private localeservice: LocaleService
  ) {}

  ngOnInit(): void {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if (!this.initializationservice.checkApp(appname)) {
      this.initializationservice.reloadApp(appname);

      return;
    }

    var orderType = this.currentorderservice.getOrderType();

    this._categories = this.itemmenuservice.getCategories(orderType);

    this.isRedirect =
      String(this.route.snapshot.queryParamMap.get('isredirect')) === 'true';

    this.updateOrderBadge();

    if (this.currentorderservice.shouldShowItemAddedPage()) {
      this.canDeactivate = true;

      var appname = String(this.route.snapshot.paramMap.get('appname'));

      this.router.navigateByUrl('/' + appname + '/itemadded');
    }
  }

  setStickyTop() {
    var topbar = document.getElementById('topbar');
    var categorypicker = document.getElementById('categorypicker');

    if (topbar && categorypicker) {
      categorypicker.style.top = `${topbar.offsetHeight}px`;

      for (let index = 0; index < this._categories.length; index++) {
        const category = this._categories[index];

        var element = document.getElementById('header' + category.ID);

        if (element)
          element.style.top = `${
            topbar.offsetHeight + categorypicker.offsetHeight
          }px`;
      }
    } else if (topbar) {
      for (let index = 0; index < this._categories.length; index++) {
        const category = this._categories[index];

        var element = document.getElementById('header' + category.ID);

        if (element) element.style.top = `${topbar.offsetHeight}px`;
      }
    }
  }

  ngAfterViewInit() {
    this.setStickyTop();
  }

  updateOrderBadge() {
    this.orderitemcount = this.currentorderservice.getOrderItemCount();

    this.showOrderBar = this.orderitemcount > 0;
  }

  back() {
    if (this.orderitemcount === 0) this.currentorderservice.clear();

    this.navigationservice.back();
  }

  canReturn() {
    if (this.orderitemcount === 0) return true;

    if (this.canDeactivate === true) {
      this.canDeactivate = false;

      return true;
    }

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if (!this.initializationservice.checkApp(appname)) return true;

    return new Promise<boolean>((resolve, reject) => {
      let dialogRef = this.alertDialog.open(AlertDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: {
          title: this.localeservice.instantTranslation(
            'Dialogs.Alert.OrderDiscardWarning.Title'
          ),
          detail: this.localeservice.instantTranslation(
            'Dialogs.Alert.OrderDiscardWarning.Detail'
          ),
          accept: this.localeservice.instantTranslation(
            'Dialogs.Alert.OrderDiscardWarning.Accept'
          ),
          cancel: this.localeservice.instantTranslation(
            'Dialogs.Alert.OrderDiscardWarning.Cancel'
          ),
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) this.currentorderservice.clear();

        resolve(result);
      });
    });
  }

  categoryTap(categoryID: string) {
    var element = document.getElementById(categoryID);

    if (element) this.scrollTo(element);

    var elementButton = document.getElementById('button' + categoryID);

    if (elementButton) this.scrollToCategoryPicker(elementButton);
  }

  goToOrder() {
    this.canDeactivate = true;

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname + '/currentorder');
  }

  goHome() {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname);
  }

  scrollTo(element: HTMLElement) {
    var topbar = document.getElementById('topbar');
    var categoryPicker = document.getElementById('categorypicker');

    if (topbar && categoryPicker) {
      var bounds = element.getBoundingClientRect();

      window.scrollTo({
        top:
          bounds.top +
          window.scrollY -
          topbar.offsetHeight -
          categoryPicker.offsetHeight,
        behavior: 'smooth',
      });
    }
  }

  scrollToCategoryPicker(element: HTMLElement) {
    var categoryPicker = document.getElementById('categorypicker');

    var bounds = element.getBoundingClientRect();

    if (categoryPicker)
      categoryPicker.scrollTo({
        left: bounds.left + categoryPicker.scrollLeft - 50,
        behavior: 'smooth',
      });
  }

  goToItem(item: ItemDisplayData) {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if (item.Type === 'combo') {
      if (item.OutOfStock) {
        this.alertDialog.open(AlertDialogComponent, {
          height: 'fit-content',
          width: 'fit-content',
          data: {
            title: this.localeservice.instantTranslation(
              'Dialogs.Alert.ComboOutOfStockWarning.Title'
            ),
            detail: this.localeservice.instantTranslation(
              'Dialogs.Alert.ComboOutOfStockWarning.Detail'
            ),
            accept: this.localeservice.instantTranslation(
              'Dialogs.Alert.ComboOutOfStockWarning.Accept'
            ),
          },
        });

        return;
      }

      this.canDeactivate = true;

      this.router.navigateByUrl(
        '/' + appname + '/combo/' + item.UniversalID + '?status=new'
      );
    }

    if (item.Type === 'item') {
      if (item.OutOfStock) {
        this.alertDialog.open(AlertDialogComponent, {
          height: 'fit-content',
          width: 'fit-content',
          data: {
            title: this.localeservice.instantTranslation(
              'Dialogs.Alert.ItemOutOfStockWarning.Title'
            ),
            detail: this.localeservice.instantTranslation(
              'Dialogs.Alert.ItemOutOfStockWarning.Detail'
            ),
            accept: this.localeservice.instantTranslation(
              'Dialogs.Alert.ItemOutOfStockWarning.Accept'
            ),
          },
        });

        return;
      }

      this.canDeactivate = true;

      this.router.navigateByUrl(
        '/' + appname + '/menuitem/' + item.UniversalID + '?status=new'
      );
    }
  }
}
